export enum AuditionStatus {
  AUDITIONED = 'Auditioned',
  SCHEDULED = 'Scheduled',
  NEW = 'New',
  NEED_EDIT = 'Need Edit',
  CD_APPROVAL = 'CD Approval',
  CD_RESCHEDULE = 'CD Reschedule',
  APPROVED = 'Approved',
  HIDDEN = 'Hidden',
  CALLBACK = 'Callback',
  RELEASED = 'Released',
  REQUESTED = 'Requested',
  DECLINED = 'Declined',
  CONFIRMED = 'Confirmed',
  NO_SHOW = 'No Show',
  LATE = 'Late',
  WAITING = 'Waiting',
  CHECKED_IN = 'Checked In',
  RESCHEDULE = 'Reschedule',
  OVERTIME = 'Overtime',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending',
  RESCHEDULE_FORWARDED = 'Reschedule Forwarded',
  DECLINED_FORWARDED = 'Declined Forwarded',
  OVERTIME_AUDITIONED = 'Overtime Auditioned',
  NO_RESPONSE = 'No Response',
  INFO_REQUEST = 'Info Request',
  FOR_REVIEW = 'For Review',
  REJECTED = 'Rejected',
  SUBMITTED = 'Submitted',
  FORWARDED = 'Forwarded',
  LATE_AUDITIONED = 'Late Auditioned',
  LATE_CHECKED_IN = 'Late Checked In',
  LATE_OVERTIME = 'Late Overtime',
  LATE_OVERTIME_AUDITIONED = 'Late Overtime Auditioned',
  IMPORTED = 'Imported',
  ON_AVAIL = 'On Avail',
  BOOKED = 'Booked',
  ALL = 'All',
  ST_REVIEW = 'ST Review',
  SHARED = 'Shared',
  VIEWED = 'Viewed',
  ST_COMPLETED = 'ST Completed',
  NO_SUBMISSION = 'No Submission',
}
